import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.trouble-ticket-bild';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationTroubleTicketBildEffects {

    TroubleTicketBild$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_TROUBLE_TICKET_BILD),
        mergeMap((x: ac.GetTroubleTicketBildAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getTroubleTicketBild(x.troubleticket_id, x.bild_id).pipe(
                map((result: any) => {
                    return new ac.GetTroubleTicketBildErfolgreichAction(result, x.troubleticket_id, x.bild_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetTroubleTicketBildFehlerAction(error, x.troubleticket_id, x.bild_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketQueryService);
        }
        return this.service;
    }
}
